export const who5CardData = [
  {
    title: "Puntuación Global",
    dataKey: "totalSumWho5",
  },
];
